import React from "react";
import useReveal from "../../hooks/useReveal";
import CopyEmail from "@/components/site/CopyEmail";

export const BookingCTA = () => {
  const ref = useReveal();
  return (
    <section
      id="reach"
      ref={ref}
      data-testid="booking-cta-section"
      className="relative scroll-mt-24 bg-black text-white px-6 sm:px-8 py-32 sm:py-48 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "3px 3px",
        }}
      />

      <div className="relative max-w-7xl mx-auto text-center">
        <p className="reveal text-xs uppercase tracking-[0.35em] text-white/60 mb-8">
          Reserve your ride
        </p>
        <h2
          className="reveal reveal-delay-1 font-display"
          style={{
            fontSize: "clamp(2.75rem, 9vw, 8rem)",
            lineHeight: 0.95,
            letterSpacing: "-2.46px",
          }}
        >
          Begin the <span className="italic text-white/60">journey.</span>
        </h2>

        <p className="reveal reveal-delay-2 mt-10 mx-auto max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed">
          Tell us when you'd like to ride. We'll prepare the bikes, the
          helmets, and a quietly beautiful route along the Pacific.
        </p>

        <div
          data-testid="booking-cta-contact"
          className="mt-14 sm:mt-16 flex flex-col items-center"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">
            Reach us
          </p>
          <CopyEmail
            data-testid="booking-cta-email"
            className="mt-4 font-display text-2xl sm:text-3xl md:text-4xl text-white hover:text-white/90 transition-colors cursor-pointer text-center"
            copiedLabel="Copied!"
          />
          <p className="mt-3 text-sm text-white/60">
            Click to copy · Replies within an hour
          </p>
        </div>
      </div>
    </section>
  );
};

export default BookingCTA;
